<template>
  <!-- <PostLoginHeader /> -->
  <main
    style="min-height: 87vh"
    class="bg-light d-flex align-items-center flex-column col-12"
  >
    <div class="card shadow vh-75 m-5 col-12 col-lg-10 p-0">
      <div class="card-header">
        <h1 class="fw-bold fs-1">Welcome to Crime Time!</h1>
      </div>
      <div class="d-flex justify-content-evenly card-body tab-col">
        <div v-if="casesEnabled" class="col-lg-5 col-12 card p-0 shadow tab-mb-2">
          <div class="card-header">
            <h3 class="fw-bold fs-3">Multi Count Sentencing</h3>
          </div>
          <div class="card-body p-5">
            <p class="fs-5 fw-bold">
              Calculate exposure, probation, consequences, release date, and more in
              minutes!
            </p>
            <ol class="fs-5 pl-5">
              <li class="pl-0 mb-4">Create a Case</li>
              <li class="pl-0 mb-4">Select your Charges</li>
              <li class="pl-0 mb-4">Play "What If?"</li>
              <li class="pl-0 mb-4">Generate Customized Report PDFs</li>
            </ol>
            <a href="/Cases" class="btn btn-primary btn-lg fs-3 col-12">
              Case List <i class="fa fa-arrow-right"></i>
            </a>
          </div>
        </div>
        <div class="col-lg-5 col-12 d-flex flex-column justify-content-between p-0">
          <div v-if="crimeSearchEnabled" class="card shadow w-100 p-0 mb-5">
            <div class="card-header">
              <h3 class="fw-bold fs-3">Single Crime Lookup</h3>
            </div>
            <div class="card-body p-5">
              <p class="fs-5 fw-bold">Find just the Crime you're looking for!</p>
              <p class="fs-5">
                Use our powerful engine to search thousands of crimes, current and sunset,
                and find out everything you need to know fast.
              </p>
              <a href="/singleSearch" class="btn btn-primary btn-lg fs-3 col-12">
                Search <i class="fa fa-search"></i>
              </a>
            </div>
          </div>
          <div v-if="creditCalculatorEnabled" class="card shadow w-100 p-0">
            <div class="card-header">
              <h3 class="fw-bold fs-3">Release Date Calculator</h3>
            </div>
            <div class="card-body p-5">
              <p class="fs-5 fw-bold">Find out just how much time you're looking at!</p>
              <p class="fs-5">
                With CrimeTime, we'll help you calculate the exact date a defendant will
                be released from incarceration.
              </p>
              <a href="/creditCalculator" class="btn btn-primary btn-lg fs-3 col-12">
                Calculate <i class="fa fa-search"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import PostLoginHeader from "../Authentication/PostLoginHeader.vue";
import { isModuleEnabled, getStoredModuleAccess } from "../../moduleAccess.js";
export default {
  name: "LandingPage",
  components: { PostLoginHeader },
  data() {},
  computed: {
    casesEnabled() {
      return isModuleEnabled(getStoredModuleAccess()?.availableModules, "cases");
    },
    crimeSearchEnabled() {
      return isModuleEnabled(getStoredModuleAccess()?.availableModules, "crimeSearch");
    },
    creditCalculatorEnabled() {
      return isModuleEnabled(getStoredModuleAccess()?.availableModules, "creditCalculator");
    },
  },
};
</script>
<style>
.vh-75 {
  min-height: 75vh !important;
}
</style>
